export default [
    {
        name: 'Despesas',
        url: '/despesasgerais/fornecedores/despesas',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'FORNECEDOR'
        },
        regras: 'DESP-GERAIS-FORN-00'
    },
    {
        name: 'Pagamentos',
        url: '/despesasgerais/fornecedores/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'FORNECEDOR'
        },
        regras: 'DESP-GERAIS-FORN-PAG-00'
    },
]